/* global __webpack_public_path__:writable */
/* exported __webpack_public_path__ */

let domain = new URL(document.currentScript.src);
export default __webpack_public_path__ = domain.protocol + '//' + domain.host + '/';